<template>
  <ul class="my-0">
    <li class="list-group-item my-1">
      <button
        class="btn btn-primary btn-xs"
        @click="createChild(location.id)"
        v-if="user && user.role_id == 1"
      >
        <i class="fa fa-plus"></i>
      </button>
      <template v-if="user && user.role_id == 1">
        <span
          class="ms-3 lead border-dark border-bottom"
          v-if="edited_location != location"
          @click="editChild(location)"
          >{{ location.name }}</span
        >
        <form v-else @submit.prevent="updateLocation()" class="d-inline-block">
          <input
            @blur="updateLocation()"
            @focus="$event.target.select()"
            :ref="'child_name_input_' + location.id"
            type="text"
            v-model="edit.name"
            class="form-control-sm ms-3"
          />
        </form>
      </template>
      <span v-else>{{ location.name }}</span>
      <div
        style="max-width: 500px"
        class="d-inline-block"
        v-if="!location.parent_id"
      >
        <div class="input-group ms-4" v-if="location_leads">
          <span class="input-group-text">területvezető</span>
          <v-select
            v-if="location_leads"
            v-model="location_local.leader_id"
            :options="location_leads"
            label="name"
            :reduce="(option) => option.id"
            @option:selected="updateLocationBetter"
            :disabled="!(user && user.role_id == 1)"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                :placeholder="
                  location_local.leader_id == null ? 'Válassz!' : ''
                "
              />
            </template>
          </v-select>
        </div>
      </div>
      <button
        @click="deleteLocation(location)"
        v-if="user && user.role_id == 1 && location.children.length == 0"
        class="btn btn-danger float-end btn-xs"
        title="törlés"
      >
        <i class="fa fa-trash"></i>
      </button>
      <location-row
        @child-deleted="deleteChild"
        @child-added="createChild"
        v-for="child in location.children"
        :key="child.id"
        :location="child"
      ></location-row>
    </li>
  </ul>
</template>

<script>
import Location from "../apis/Location";
import Confirmation from "../apis/Confirmation";

export default {
  props: ["depth", "location", "location_leads"],
  name: "location-row",
  data() {
    return {
      edit: "",
      location_local: {},
    };
  },
  created() {
    this.location_local = JSON.parse(JSON.stringify(this.location));
  },
  computed: {
    indent() {
      return { transform: `translate(${this.depth * 50}px)` };
    },
    edited_location() {
      return this.$store.state.edited_location;
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    createChild(id) {
      this.$emit("child-added", id);
    },
    deleteChild() {
      this.$emit("child-deleted");
    },
    editChild(location) {
      this.edit = location;
      new Promise((resolve) => {
        this.$store.commit("updateEditedLocation", location);
        resolve("finished");
      }).then(() => {
        this.$refs["child_name_input_" + location.id].focus();
      });
    },
    updateLocation() {
      Location.update(this.edit.id, this.edit).then(() => {
        this.$store.commit("updateEditedLocation", {});
        this.edit = "";
      });
    },
    updateLocationBetter() {
      Location.update(this.location_local.id, this.location_local).then(() => {
        this.$store.commit("updateEditedLocation", {});
        this.edit = "";
      });
    },

    deleteLocation(location) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Location.delete(location.id)
            .then(() => {
              this.deleteChild();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
